import { Container } from 'react-bootstrap';

import { BannerSlideSkelton } from '@/views/HomeView/BannerSlider/BannerSlide';
import styles from '@/views/HomeView/BannerSlider/BannerSlider.module.scss';

export const BannerSliderSkelton = () => {
  return (
    <Container as="section">
      <div className={styles.bannerSliderWrapper}>
        <div
          style={{
            width: '56.3vw',
            margin: '0 auto',
          }}
        >
          <BannerSlideSkelton />
        </div>
      </div>
    </Container>
  );
};
